import { ValidationBoxProps } from "./types";

const ValidationBox = ({ children }: ValidationBoxProps) => (
  <div className="flex items-center min-h-12 border-l-4 border-l-red mt-2 py-2 pl-4 pr-5 bg-greyBackground w-full shadow-lg shadow-greyShadow transition-all duration-450">
    {children}
  </div>
);

export default ValidationBox;
